const tableTitleManagementBackups = {
  title: 'Géstion de Backups (App)',
  placeholder: 'Buscar',
};

export default tableTitleManagementBackups;
